import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServerService } from '../service/server.service';
import { ToastController,NavController,Platform,LoadingController,AlertController,ModalController,IonRouterOutlet,ActionSheetController } from '@ionic/angular';
import { IncomeaddPage } from '../incomeadd/incomeadd.page';
import {Constant} from "../shared/model/Constant";

@Component({
  selector: 'app-income',
  templateUrl: './income.page.html',
  styleUrls: ['./income.page.scss'],
})

export class IncomePage implements OnInit {

 data:any;
 user:any;
 total:any;
 show = false;
 from:any;
 to:any;
 q:any;
 text:any;
 date:any;
 f:any;

  constructor(public actionSheetController: ActionSheetController,private routerOutlet: IonRouterOutlet,public modalController: ModalController,public alertController: AlertController,private route: ActivatedRoute,public server : ServerService,public toastController: ToastController,private nav: NavController,public loadingController: LoadingController){

  this.user = JSON.parse(localStorage.getItem(Constant.userData));
  this.text = JSON.parse(localStorage.getItem(Constant.appText));

  }

  ngOnInit()
  {
    this.loadData();
  }

  showPre()
  {
    this.show = this.show == true ? false : true;

    if(!this.show)
    {
      this.from = undefined;
      this.to   = undefined;

      return this.loadData();
    }
  }

  async loadData(id = 0)
  {
    const loading = await this.loadingController.create({
      message: '',
      spinner : 'bubbles',
      duration:3000
    });
    await loading.present();

    this.server.getIncome(id,this.from,this.to).subscribe((response:any) => {

    this.data   = response.data;
    this.total  = response.total;

    loading.dismiss();

    });
  }

  async add(data)
  {
    const loading = await this.loadingController.create({
      message: '',
      spinner : 'bubbles',
      duration:3000
    });
    await loading.present();

    this.server.incomeAdd(data).subscribe((response:any) => {

    this.presentToast(this.text.update_success);

    this.data  = response.data.data;
    this.total = response.data.total;

    loading.dismiss();

    });
  }


  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position : 'top',
      mode:'ios',
      color:'dark'
    });
    toast.present();
  }

  async addIncome(data = []) {
    const modal = await this.modalController.create({
      component: IncomeaddPage,
      animated:true,
      mode:'ios',
      cssClass: 'my-custom-modal-css',
      backdropDismiss:true,
      swipeToClose: true,
      componentProps: {
        'data': data,
      }

    });

   modal.onDidDismiss().then(data=>{

    if(data.data.amount)
    {
      this.add(data.data);
    }

    })

    return await modal.present();
  }

  async presentAlert(id) {
    const alert = await this.alertController.create({
      header: this.text.are_you_sure,
      message: this.text.no_undo,
      mode:'ios',
      buttons: [
        {
          text: this.text.cancel,
          role: 'cancel',
          handler: () => {
          },
        },
        {
          text: this.text.yes,
          role: 'confirm',
          handler: () => {

            this.loadData(id);

          },
        },
      ],
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
  }

  async presentActionSheet(income) {

    if(income.type != 0)
    {
      return this.presentToast(this.text.invoice_entry);
    }

    const actionSheet = await this.actionSheetController.create({
      header: this.text.action,
      cssClass: 'my-custom-class',
      buttons: [{
        text: this.text.edit,
        role: 'destructive',
        icon: 'create',
        id: 'delete-button',
        data: {
          type: 'delete'
        },
        handler: () => {

          this.addIncome(income);

        }
      }, {
        text: this.text.delete,
        icon: 'trash',
        data: 10,
        handler: () => {

          this.presentAlert(income.id);

        }
      }, {
        text: this.text.cancel,
        icon: 'close',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });
    await actionSheet.present();

    const { role, data } = await actionSheet.onDidDismiss();
    console.log('onDidDismiss resolved with role and data', role, data);
  }
}
